import { render, staticRenderFns } from "./BaseLineBox.vue?vue&type=template&id=62ab50aa&"
import script from "./BaseLineBox.vue?vue&type=script&lang=js&"
export * from "./BaseLineBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseLineBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports